<template>
    <swiper class="swiper d-sm-none" :options="swiperOption" ref="mySwiper">
      <swiper-slide
        v-for="(item, index) in gallery"
        style="text-align: center"
        :key="'swiper' + item.url + index"
      >
        <!-- <img
                  :src="item.url"
                  class="swiper-lazy"
                  style="max-width:100%;max-height:575px;"
                  @error.once="imageFailure"
                  alt
                />-->
        <img
          :data-srcset="item.srcset"
          data-sizes="auto"
          class="swiper-lazy lazyload"
          @error.once="imageFailure"
          @load="swiper.update()"
          style="max-width: 360px; max-height: 375px"
          alt
        />
        <!-- srcset配置 -->
      </swiper-slide>
      <div v-if="gallery.length>1" class="swiper-pagination" slot="pagination"></div>
    </swiper>
</template>
<script>
export default {
  props: ["gallery"],
  data() {
    return {
      swiperOption: {
        allowTouchMove: true,
        autoHeight: true, //enable auto height
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        loop: true,
      },
    };
  },
  beforeMount() {
      if (this.gallery.length <= 1) {
      this.swiperOption.allowTouchMove = false;
      }
  },
  mounted() {
    console.log("this.gallery", this.gallery);
  },
  computed: {
    //获取swiper实例
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  watch:{
    "$store.state.feature_image_id"() {
      this.gallery.some((item, index) => {
        if (item.ID == this.$store.state.feature_image_id) {
          this.swiper.slideTo(index + 1);
        }
      });
    }
  }
};
</script>
<style scoped lang='scss'>
.swiper {
  .swiper-pagination {
    padding: 10px 0;
    position: relative;
    background: #f7f7f7;
    bottom: 0;
    .swiper-pagination-bullet {
      background: black;
      opacity: 0.1;
    }
    .swiper-pagination-bullet-active {
      opacity: 1;
    }
  }
}
</style>